export function dailyEnergyPerItem (item) {
  return Math.round(item.wattage*item.intensity/100*item.usage/1000*item.units*100)/100;
}

export function monthlyEnergyPerItem (item) {
  return Math.round(dailyEnergyPerItem(item)*item.days*100)/100;
}

export function dailyCostPerItem (item, cost) {
  return Math.round(dailyEnergyPerItem(item)*cost*100)/100;
}

export function monthlyCostPerItem (item, cost) {
  return Math.round(monthlyEnergyPerItem(item)*cost*100)/100;
}
